import ReactGA from 'react-ga4';

let isInitialized = false;

// Check if user has consented to cookies
export const hasConsent = () => {
  const consent = localStorage.getItem('cookieConsent');
  return consent === 'accepted';
};

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (!measurementId) {
    console.warn('Google Analytics Measurement ID not found');
    return false;
  }
  
  // Only initialize if user has consented
  if (!hasConsent()) {
    return false;
  }
  
  if (!isInitialized) {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        anonymizeIp: true, // Anonymize IP addresses for privacy
      }
    });
    isInitialized = true;
  }
  
  return true;
};

export const trackPageView = (path, title) => {
  if (isInitialized && hasConsent()) {
    ReactGA.send({ hitType: 'pageview', page: path, title: title });
  }
};

export const trackEvent = (category, action, label = '', value = 0) => {
  if (isInitialized && hasConsent()) {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value
    });
  }
};

export const trackFormSubmission = (formName, success = true) => {
  trackEvent('Form', success ? 'Submit Success' : 'Submit Failed', formName);
};

export const trackTestCompletion = (testType, score, totalQuestions) => {
  const percentage = Math.round((score / totalQuestions) * 100);
  trackEvent('Test', 'Completed', testType, percentage);
};

export const trackModalOpen = (modalName) => {
  trackEvent('Modal', 'Open', modalName);
};

export const trackNavigation = (destination) => {
  trackEvent('Navigation', 'Click', destination);
};
